export interface ActionViewer {
  actionId: string;
  userId: string;
  username: string;
}
export type ActionPresence = Record<string, ActionViewer>;
export function presenceMessage(payload: unknown): ActionViewer | null {
  if (!payload || typeof payload !== "object") return null;
  const p = payload as Record<string, unknown>;
  const actionId = p.actionId ?? p.ActionId;
  const userId = p.userId ?? p.UserId;
  const username = p.username ?? p.Username;
  if (
    typeof actionId !== "string" ||
    !actionId ||
    typeof userId !== "string" ||
    !userId
  )
    return null;
  return {
    actionId,
    userId,
    username:
      typeof username === "string" && username.trim()
        ? username
        : "Another user",
  };
}
export function updatePresence(
  current: ActionPresence,
  event: string,
  payload: unknown,
): ActionPresence {
  const message = presenceMessage(payload);
  if (event === "ActionClosed" || event === "ActionClosedWithNew" || event === "ActionDeleted") {
    const p = payload as Record<string, unknown> | null;
    const id =
      p?.actionId ?? p?.ActionId ?? p?.closedActionId ?? p?.ClosedActionId;
    if (typeof id !== "string" || !current[id]) return current;
    const next = { ...current };
    delete next[id];
    return next;
  }
  if (!message) return current;
  if (event === "ActionLocked") {
    // Match the source: a user views one action; the first viewer owns presence.
    if (
      current[message.actionId] &&
      current[message.actionId].userId !== message.userId
    )
      return current;
    return {
      ...Object.fromEntries(
        Object.entries(current).filter(
          ([, viewer]) => viewer.userId !== message.userId,
        ),
      ),
      [message.actionId]: message,
    };
  }
  if (
    (event === "ActionUnLocked" || event === "ActionUnlocked") &&
    current[message.actionId]?.userId === message.userId
  ) {
    const next = { ...current };
    delete next[message.actionId];
    return next;
  }
  return current;
}
export function otherViewer(
  presence: ActionPresence,
  actionId: string,
  currentUserId?: string,
): ActionViewer | null {
  const viewer = presence[actionId];
  return viewer && viewer.userId !== currentUserId ? viewer : null;
}
